import { render, staticRenderFns } from "./Customer-Search.vue?vue&type=template&id=7012e4b7"
import script from "./Customer-Search.vue?vue&type=script&lang=js"
export * from "./Customer-Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports